module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVChTY0AGjMzsnNzWHcu4bXvXMLJwckOFwYAJSgNZbOycJlVTGJhY2Rj+/f7FZVoznZGFgwsqCwWMzCzc1p3LuW16VoPYQAFGbqv2pSCTwRrBAMjgtmpbzGPXvx6kgJlfWZtZUF0fJMVt3bWC26Z7JchJQJ1tSxgYWVi+Hi2LYOZX0gK7D8j/cqQ0/O/7G+fB8v/+/GZgU/KLZ2Tl5gWZwue56jybglcUm5xrCJ/X2svMQlrGIE+xSlq6gW0HK/Jed4VdOSgFLAAEbIo+sXw+G28wC2mbgAWYhTSNgCZdYFMKSAQLIAGQ6SADWEQMrBh4HKZuY1cJSYPKYQB25YAkbqu2xQCglT8vgQuCcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/electricity/top_arrow1.png
// module id = Eqi5
// module chunks = 1